import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL
const APP_URL = process.env.VUE_APP_APP_URL

export class Api{

	constructor(){}

	get(uri) {
		const url = API_URL+uri;
		var self = this;
	    return axios.get(url, {
			withCredentials: true,
			validateStatus: function( status ){
				if( status == 403 ){
					// window.location.href = APP_URL + "login";
				}
				return true;
			}
		} ).then(function (response) {
			return response.data;
  		});
	}

	post(uri, params) {
		const oParams = new URLSearchParams();
		Object.keys( params ).forEach( key => {
			oParams.append( key , params[ key ] );
		});

	    const url = API_URL+uri;
		return axios.post(url, oParams,
			{
				withCredentials: true,
				validateStatus: function( status ){
					if( status == 403 ){
						// window.location.href = APP_URL + "login";
					}
					return true;
				}
			}
		).then(function (response) {
			return response.data;
		})
	}

	language(lang) {
		const url = API_URL + '/inscriptions/language/' + lang;
		var self = this;
	    return axios.get(url, {
			withCredentials: true,
			validateStatus: function( status ){
				if( status == 403 ){
					// window.location.href = APP_URL + "login";
				}
				return true;
			}
		} ).then(function (response) {
			return response.data;
  		});
	}

}
